module.exports = __webpack_public_path__ + "fonts/EuclidEnercity-Bold-WebS.563473d6.woff2";